import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIState {
  // Theme
  theme: "light" | "dark";
  toggleTheme: () => void;

  // Modals/Dialogs
  isEmojiPickerOpen: boolean;
  setEmojiPickerOpen: (open: boolean) => void;

  // Notifications (Simplified)
  notification: { message: string; type: "success" | "error" | "info" } | null;
  showNotification: (
    message: string,
    type: "success" | "error" | "info"
  ) => void;
  clearNotification: () => void;

  // Layout
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      theme: "light",
      toggleTheme: () => set((state) => ({ theme: state.theme === "light" ? "dark" : "light" })),
      
      isEmojiPickerOpen: false,
      setEmojiPickerOpen: (open) => set({ isEmojiPickerOpen: open }),

      notification: null,
      showNotification: (message, type) => set({ notification: { message, type } }),
      clearNotification: () => set({ notification: null }),

      sidebarCollapsed: false,
      toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
    }),
    {
      name: "ui-storage",
      partialize: (state) => ({ theme: state.theme }),
    }
  )
);
